import OnboardingForm from './OnboardingForm'

export default OnboardingForm